import React                from 'react';
import classnames           from 'classnames';

import Card                 from 'react-bootstrap/Card';
import Description          from './shared/Description';
import ProductImage         from './shared/ProductImage';
import Quantity             from './shared/Quantity';
import Title                from './shared/Title';
import UnitPrice            from './shared/UnitPrice';

const Accessory = ({accessory, accessoryClassName, onChangeQuantity, onChangeVariant, onSelect}) => {

  const {
    images,
    index,
    name,
    product_url,
    quantity,
    selected,
    selected_variant,
    short_description,
    slug,
  } = accessory;

  const onChangeQty = (qty) => {
    onChangeQuantity(index, qty)
  }

  return (
    <Card className={classnames("accessory-item", accessoryClassName)}>
      <Card.Body>
        <Title 
          id={`accessory-checkbox-select-${index}`}
          name={`accessory-checkbox-select-${index}`}
          title={name}
          checked={selected}
          product_url={product_url}
          onChange={() => onSelect(index)}/>
        <Description 
          product_slug={slug} 
          description={short_description}/>
        <Quantity 
          quantity={quantity}
          onChangeQuantity={onChangeQty}/>
        <UnitPrice 
          variant={selected_variant}/>
        <ProductImage
          product_name={name}
          product_slug={slug}
          product_url={product_url}
          images={images}/>
      </Card.Body>
    </Card>
  )
}

export default Accessory;